require("./alert_center.coffee");
